export const SET_FLAGS = 'FEATURE_FLAGS/SET_FLAGS';
export const SET_LOADED = 'FEATURE_FLAGS/SET_LOADED';
